import React from 'react'
import HousePublicOn from 'src/assets/img/house/house_public_btn_on.png'
import HousePublicOff from 'src/assets/img/house/house_private_btn_off.png'
import PropTypes from 'prop-types'

const HousePublicButton = ({ isPublic, setIsPublic }) => {
  return (
    <button onClick={setIsPublic} className="">
      {isPublic ? (
        <img src={HousePublicOn} alt="public" className="h-6" />
      ) : (
        <img src={HousePublicOff} alt="private" className="h-6" />
      )}
    </button>
  )
}

HousePublicButton.propTypes = {
  isPublic: PropTypes.bool,
  setIsPublic: PropTypes.func
}

export default HousePublicButton
